import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { FMS_READ_SCOPE, fmsReadBasePath } from '#/api/fmsMgmt/fmsReadScope';

/** GET `/fms/vouchers/{id}`（`.read`）或 `/fms/vouchers/self/{id}`（`.self`） */
export async function fetchVoucherDetail(id, { scope = FMS_READ_SCOPE.ALL } = {}) {
  const { data: raw } = await request.get(`${fmsReadBasePath('vouchers', scope)}/${id}`);
  return parseVer4DetailResponse(raw);
}
